import type { OcrRegion } from '@api/ocr/api'

const clamp = (value: number) => Math.min(1, Math.max(0, value))

export const pointerPoint = (clientX: number, clientY: number, box: {left: number; top: number; width: number; height: number}) => ({
    x: clamp((clientX - box.left) / Math.max(1, box.width)),
    y: clamp((clientY - box.top) / Math.max(1, box.height)),
})

export const rectangleBetween = (start: {x: number; y: number}, end: {x: number; y: number}): OcrRegion => ({
    x: Math.min(start.x, end.x), y: Math.min(start.y, end.y),
    width: Math.abs(end.x - start.x), height: Math.abs(end.y - start.y),
})

export const validRegion = (region: OcrRegion) => Object.values(region).every(Number.isFinite)
    && region.x >= 0 && region.y >= 0 && region.width > 0 && region.height > 0
    && region.x + region.width <= 1.000001 && region.y + region.height <= 1.000001

export const isOcrRoot = (loginName: unknown) => loginName === 'root'
